import React, { useEffect } from "react";
import { connect } from "react-redux";
import PolylineWrapper from "./PolylineWrapper";
import {
  setExpandedRoutes,
  setShowingRouteId
} from "../../store/actions/project";
import { setProjectTabValue } from "../../store/actions/common";
import { isNotEmptyRoute } from "../../utils/helpers";
import { fetchRoutes } from "../../store/actions/map";
import { routeColors } from "../data/constants";

function Polylines({
  polylines,
  emptyRoutesVisible,
  fetchRoutes,
  expandedRoutes,
  hiddenRoutes,
  visibleRoutes,
  colorsObj,
  mapRef,
  fullRoutes,
  setShowingRouteId,
  showingRouteId,
  setProjectTabValue
}) {
  // Polyline colors
  const getColor = id => (colorsObj[id] >= 0 ? colorsObj[id] : 0);

  // TO2DO: investigate color darken/lighten functions, use for backhaul if necessary

  useEffect(() => {
    if (fullRoutes.length > Object.keys(polylines).length) {
      fetchRoutes(fullRoutes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandedRoutes]);

  const handleRouteSelect = id => {
    setProjectTabValue(1);
    setShowingRouteId(id);
  };

  return Object.keys(polylines)
    .filter(id => polylines[id].length > 2)
    .map((routeId, index) => {
      let routeData = fullRoutes.find(
        currentRoute => currentRoute.id === routeId
      );

      return emptyRoutesVisible || isNotEmptyRoute(routeData) ? (
        <PolylineWrapper
          key={routeId}
          hidden={
            hiddenRoutes.includes(routeId) || !visibleRoutes.includes(routeId)
          }
          expanded={routeId === showingRouteId}
          positions={polylines[routeId]}
          handleClick={handleRouteSelect}
          color={routeColors[getColor(routeId) % routeColors.length]}
          routeId={routeId}
          map={mapRef.current}
          expandedRoutes={expandedRoutes}
        />
      ) : null;
    });
}

const mapStateToProps = state => ({
  solution: state.project.solution,
  polylines: state.map.polylines,
  emptyRoutesVisible: state.common.emptyRoutesVisible,
  expandedRoutes: state.common.expandedRoutes,
  selectedVehicles: state.project.selectedVehicles,
  hiddenRoutes: state.map.hiddenRoutes,
  colorsObj:
    (state.project.solution && state.project.solution.routeColors) || {},
  expandedFromMap: state.common.expandedFromMap,
  showingRouteId: state.project.showingRouteId
});

export default connect(mapStateToProps, {
  fetchRoutes,
  setExpandedRoutes,
  setShowingRouteId,
  setProjectTabValue
})(Polylines);
